import React from 'react'
import comprovante from '../images/foto_comprovante.png'
import FadeIn from 'react-fade-in';
import { Button, Card, CardBody, CardText, CardTitle, Input } from 'reactstrap';
import './styles/estilo.css'
//import { tela_fluxo } from '../telas_id';
import Loading from '../components/Loading'

import {videocons, Banner, CardInfo, BoxInfo, OpcoesBtn, ResPic, ButtonsInline, Command} from './styles/estilo_telas'
import Document from '../components/Document'
import Camera from '../components/CameraFluxo'

import {ApresentacaoText, OpcaoText, AnexarText, TirarFotoText} from './text/comprovate.text'
import { FiletoBase64, IsFileUpperBound, IsValidExtension } from '../util/Utils'

import { status, situacao } from '../components/Info';

import { PropTelaDoc, HTMLInputEvent } from '../ts/interfaces/PropTelas.interfaces';
import { Base64Type } from '../ts/types/Types';
import Webcam from 'react-webcam';

import {isBrowser} from 'react-device-detect';
import { updateInfoBPO } from '../state/actions/Info_actions';

const tela = {
  apresentacao: 0,
  opcao: 1,
  anexar: 2,
  tirarfoto: 3
}

interface State {
  data: Base64Type,
  datab64: Base64Type,
  dataUrl: string | null,
  step: number,
  refazer: boolean
}

const {REACT_APP_PERFIL} = process.env

export default class ResidenciaDesktop extends React.Component<PropTelaDoc, State> {
  webcam: React.RefObject<Webcam>

  constructor(props : PropTelaDoc){
    super(props)
    this.Apresentacao = this.Apresentacao.bind(this)
    this.Opcao = this.Opcao.bind(this)
    this.Anexar = this.Anexar.bind(this)
    this.TirarFoto = this.TirarFoto.bind(this)
    this.Takecapture = this.Takecapture.bind(this)
    this.ProximoPasso = this.ProximoPasso.bind(this)
    this.SeguirAnexo = this.SeguirAnexo.bind(this)
    this.SeguirFoto = this.SeguirFoto.bind(this)
    this.CameraError = this.CameraError.bind(this)

    this.webcam = React.createRef<Webcam>()

    this.handleImage = this.handleImage.bind(this)

    this.state = {
      data: null,
      datab64: null,
      dataUrl: null,
      step: tela.apresentacao,
      refazer: true
    }
  }

  componentDidMount(){
    updateInfoBPO({fase: status.tela_comprovante_residencia, situacao: situacao.sucesso});
    //addInfo(tela_fluxo.documento_residencia);
  }

  CameraError = (e: string | DOMException) => {
    this.setState({data: null, refazer: true})
    updateInfoBPO({fase: status.comprovante_residencia_capturado, situacao: situacao.falha, mensagemErro: `Nao foi possivel acessar a camera:${e}`});
    this.props.ShowAlert(TirarFotoText.error)
  }

  async handleImage(event : HTMLInputEvent) {
    const file : File | null = event.target.files? event.target.files[0] : null
    if(file) {
      if(IsFileUpperBound(file)){
        this.props.ShowAlert(AnexarText.error)
      }else if(!IsValidExtension(file)){
        this.props.ShowAlert(AnexarText.error2)
      }else{
        this.setState({
          data: file,
          dataUrl: URL.createObjectURL(file)
        })
        const datab64 = await FiletoBase64(file)
        this.setState({datab64: datab64})
      }
    }
  }

  Apresentacao(){
    return(
      <FadeIn>
          <BoxInfo>
            <Card
              body
              className="text-center"
            >
              <CardTitle tag="h5">
                {ApresentacaoText.title1}
              </CardTitle>
              <CardText>
                {ApresentacaoText.text1}
              </CardText>
            </Card>
            <Banner src={comprovante} alt='intro-comprovante' />
            {ApresentacaoText.text2}
            <Button block={true} id={REACT_APP_PERFIL=='BPO'?'button-bpo': 'button-purple'} onClick={()=> this.setState({step: isBrowser? tela.opcao : tela.tirarfoto})}> Seguir </Button>
          </BoxInfo>
      </FadeIn>
    );
  }

  Opcao(){
    
    return(
      <FadeIn>
        <CardInfo>
          <Card 
            body
            className="text-center">
            <CardBody>
              <CardTitle tag="h5">
                {OpcaoText.title}
              </CardTitle>

              <OpcoesBtn>
                <Button color='success' onClick={()=>this.setState({step: tela.anexar})}> Anexar foto</Button>
                <Button color='info' onClick={()=>this.setState({step: tela.tirarfoto})}> Tirar Foto </Button>
              </OpcoesBtn>
            </CardBody>
          </Card>
        </CardInfo>
      </FadeIn>
    );
  }

  SeguirAnexo = () => {
    const{datab64} = this.state
    this.props.InsertScreenShot(datab64, 3)
    this.ProximoPasso()
  }

  SeguirFoto = () => {
    const{data} = this.state
    this.props.InsertScreenShot(data, 3)
    this.ProximoPasso()
  }

  ProximoPasso(){
    this.props.changePasso()
  }

  Anexar(){

    return(
      <FadeIn>
        <CardInfo>
          <Card
            body
            className="text-center">
              {this.state.data?
              <CardTitle tag="h5">
                {AnexarText.title2}
              </CardTitle>
              :
              <CardTitle tag="h5">
                {AnexarText.title1}
              </CardTitle>
              }
              <CardBody>
                <Input color='success' type='file' onChange={this.handleImage}/>
                {this.state.data && <Document alt='Anexo comprovante' src={this.state.data} url={this.state.dataUrl} />}
                {this.state.data && <Button id={REACT_APP_PERFIL == 'BPO'?'button-bpo':'button-purple'} block={true} onClick={this.SeguirAnexo}> Seguir </Button>}
              </CardBody>
          </Card>
        </CardInfo>
      </FadeIn>
    );
  }

  Takecapture = async () => {
    var screenshot = this.webcam?.current?.getScreenshot();
    if(screenshot){
      this.setState({data: screenshot, refazer: false})
    }else{
      this.props.ShowAlert(TirarFotoText.error)
    }
  }

  TirarFoto(){
    const {refazer} = this.state

    return(
      <FadeIn delay={50}>
        <div style={{marginTop: '50px', marginBottom: '100px'}}>
          <Command>
            {refazer?
            <p><b>{TirarFotoText.title1}</b></p>
            :
            <p><b>{TirarFotoText.title2}</b></p>
            }
          </Command>
          
          {refazer? 
              <Camera webcam={this.webcam} videocons={videocons} CameraError={this.CameraError} onClick={this.Takecapture} />
            : <ResPic>
            
            <img src={this.state.data as string} alt='Pic Comprovante' />
            
            {this.state.data && (
                <ButtonsInline>
                  <Button color='info' onClick={()=>this.setState({refazer: true})}> Tirar Novamente </Button>
                  <Button id={REACT_APP_PERFIL == 'BPO'?'button-bpo':'button-purple'} onClick={this.SeguirFoto}> Seguir </Button>
                </ButtonsInline>
              )
              }
            </ResPic>}

        </div>
      </FadeIn>
    );
  }

  render(){
    const {step} = this.state;
    const {enviado} = this.props;

    if(!enviado){
      return(
        <div style={{marginTop: 20}}>
          <Loading text={'Carregando...'}/>
        </div>
      );
    }

    switch(step){
      case tela.apresentacao:
        return(this.Apresentacao());
      case tela.opcao:
        return(this.Opcao());
      case tela.tirarfoto:
        return(this.TirarFoto());
      case tela.anexar:
        return(this.Anexar());
      default:
        break;
    }
    return null;
  }
  
}